function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#278AFF",
  d: "M10.007 0h.02c.023 0 .047.002.07.004L10.007 0c.05 0 .1.004.149.01l.055.01.057.014.054.016.061.023.043.018c.022.01.043.021.063.032l.043.025c.021.013.042.027.062.042l.031.023c.063.05.12.107.17.17l-.08-.09c.036.035.068.073.097.112l.05.074.021.037.031.06.023.053.021.06.014.045.016.065.009.053.004.031.003.028.004.07v8.023c0 .552-.448 1-1 1-.513 0-.936-.386-.993-.883l-.007-.117-.001-5.591-7.3 7.298c-.39.39-1.024.39-1.414 0-.36-.36-.388-.928-.083-1.32l.083-.094L7.591 2l-5.59.003c-.513 0-.936-.386-.994-.883L1 1.004c0-.512.386-.935.883-.993L2 .004 10.007 0z"
});

var SvgLink = function SvgLink(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLink, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/link.8658d7b3.svg";
export { ForwardRef as ReactComponent };